import { makeStyles } from '@mui/styles';
import { AppTheme } from '../../../../theme';

export const useStyles = makeStyles((theme: AppTheme) => ({
  title: {
    textAlign: 'center',
    paddingTop: theme.spacing(3),
  },
  button: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(6),
  },
  link: {
    textDecoration: 'none',
  },
  image: {
    width: '100%',
  },
  contentContainer: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  container: {
    minHeight: '100%',
  },
}));
